export * from './public_api';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/angularfire2/auth/index.js
// module id = ../../../../angularfire2/auth/index.js
// module chunks = 7